import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Subscription } from "rxjs"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import SfxInputPassword from "src/components/input/SfxInputPassword.vue"
import { useAuthStore } from "src/stores/authStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { Log } from "src/util/classes/log"
import { ContextSource } from "src/util/enums/contextSource"
import { ContextAction } from "src/util/enums/entityType"
import { hashUnlockKey } from "src/util/functions/hashing"
import { helpTourNotImplemented } from "src/util/functions/helpTour"
import { showErrorNotification, showSuccessNotification } from "src/util/functions/notifications"
import { onMounted, onUnmounted, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeUnlockKeyOverlay',
  emits: ["dialog-ok"],
  setup(__props, { emit: __emit }) {

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()
const authStore = useAuthStore()
const topNavigationStore = useTopNavigationStore()
const currentPassword = ref("")
const unlockKey = ref("")
let subscription: Subscription

//endregion

//region Lifecycle

onMounted(() => {
  subscription = topNavigationStore.overlayContextActionClicked.subscribe((contextAction) => {
    if (
      contextAction.source === ContextSource.CHANGE_UNLOCK_KEY &&
      contextAction.item.action === ContextAction.HELP
    ) {
      return helpTourNotImplemented("ChangeUnlockKeyOverlay")
    }
  })
})

onUnmounted(() => {
  subscription?.unsubscribe()
})

//endregion

//region Functions

async function setNewUnlockKey() {
  try {
    const hashResult = await hashUnlockKey(unlockKey.value)
    if (hashResult) {
      authStore.setUnlockKeyHashed(hashResult)

      showSuccessNotification(t("sfxDialogChangeUnlockKey.msg_unlock_key_changed"))
      emit("dialog-ok")
    } else {
      showErrorNotification(t("sfxErrorMsg.error_change_unlock_key"))
      Log.error({ message: "Failed to hash Unlock key." })
    }
  } catch (error) {
    showErrorNotification(t("sfxErrorMsg.error_change_unlock_key"))
    Log.error({ message: "Failed to set new Unlock key.", error })
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    onSubmit: setNewUnlockKey,
    class: "fit sfx-unlock-key-change-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(SfxInput, {
          "model-value": '',
          class: "hidden",
          autocomplete: "email"
        }),
        _createVNode(SfxInputPassword, {
          modelValue: currentPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
          label: _ctx.$t('sfxDialogChangeUnlockKey.input_current_password'),
          class: "q-pb-lg",
          autocomplete: "current-password"
        }, null, 8, ["modelValue", "label"]),
        _createVNode(SfxInputPassword, {
          modelValue: unlockKey.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unlockKey).value = $event)),
          label: _ctx.$t('sfxDialogChangeUnlockKey.input_unlock_key'),
          autocomplete: "new-key"
        }, null, 8, ["modelValue", "label"])
      ]),
      _createVNode(SfxBtn, {
        class: "q-mt-md sfx-unlock-key-change-button",
        label: _ctx.$t('sfxButtons.btn_unlock_key'),
        disable: !currentPassword.value || !unlockKey.value,
        type: "submit"
      }, null, 8, ["label", "disable"])
    ]),
    _: 1
  }))
}
}

})